// Конфигурация сетки по умолчанию
export const DEFAULT_GRID_CONFIG = {
  radius: 20,
  hexSize: 60,
  orientation: 'flat'
};